import { Component, inject, OnInit } from '@angular/core';
import { Mdladdproduct } from '../../components/mdl-add-product/mdl-add.product';
import { MatDialog } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { ActivatedRoute,Router  } from '@angular/router';
import { AlertService } from '../../services/alert.service';
import { CommonModule, DecimalPipe } from '@angular/common';
import { MdlModifyPItem } from '../../components/mdl-modify-p-item/mdl-modify-p-item';

@Component({
  selector: 'app-nav-budget-detail',
  imports: [DecimalPipe, CommonModule],
  templateUrl: './budget-detail-table.html',
  styleUrl: './budget-detail-table.css',
})
export class BudgetDetailTable implements OnInit {
  readonly dialog = inject(MatDialog);

  presupuestoId: string = '';
  items: any[] = [];
  isLoading = true;
  openedMenuId: string | null = null;
  showRecentDropdown: boolean = false;

  constructor(
    private api: Api,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private router: Router

  ) {}

  ngOnInit() {
    this.presupuestoId = this.route.snapshot.queryParamMap.get('id') || '';
    console.log('📦 ID recibido en BudgetDetailTable:', this.presupuestoId);

    if (this.presupuestoId) {
      this.loadBudgetItems();
    }
  }

  loadBudgetItems() {
    this.isLoading = true;
    this.api.getBudgetItems(this.presupuestoId).subscribe({
      next: (res: any) => {
        console.log('✅ Datos recibidos del backend:', res);
        this.items = res.presupuesto_items || [];
        console.log('🧮 Items cargados en el front:', this.items.length);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('❌ Error cargando items:', err);
        this.isLoading = false;
      },
    });
  }

  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false;
  }

  deleteItem(item: any) {
    if (
      !confirm(
        `¿Seguro que deseas eliminar "${item.producto_servicio}" del presupuesto?`
      )
    )
      return;

    const payload = {
      presupuesto_item_id: item.presupuesto_item_id,
      presupuesto_id: this.presupuestoId,
    };

    this.api.deleteProductBudget(payload).subscribe({
      next: (res: any) => {
        console.log('✅ Producto eliminado:', res);
        this.alertService.success('Producto eliminado', `Producto "${item.producto_servicio}" eliminado. Versión creada: v${res.nueva_version}`);
        this.loadBudgetItems();
      },
      error: (err) => {
        console.error('❌ Error al eliminar producto:', err);
        this.alertService.error('Error al eliminar', 'Error al eliminar producto');
      },
    });
  }

  openAddProductModal() {
    this.dialog.open(Mdladdproduct, {
      width: '900px',
      maxWidth: '95vw',
      minHeight: '500px',
      maxHeight: '95vh',
      panelClass: 'mat-dlg-class',
            data: {
        presupuestoId: this.presupuestoId,
      },
    });
  }


  openUpdateItems() {
    const dialogRef = this.dialog.open(MdlModifyPItem, {
      width: '900px',
      maxWidth: '95vw',
      minHeight: '500px',
      maxHeight: '95vh',
      panelClass: 'mat-dlg-class',
      data: {
        presupuestoId: this.presupuestoId,
        items: this.items,
      },
    });
  
    dialogRef.afterClosed().subscribe((saved) => {
      if (saved) {
        this.loadBudgetItems();
      }
    });
  }

  volverAlPresupuesto() {
    this.router.navigate(['/budget', this.presupuestoId]);
  }
  
  
}
